module.exports = __webpack_public_path__ + "img/AMS400V112.98f13cde.png";